// Third-party imports
import Aos from 'aos';
import smoothscroll from 'smoothscroll-polyfill';

// AW component imports
import Menu from './components/menu-custom';
import toggleCookieBanner from './components/cookie-banner';
import adBanner from './components/ad-banner';

import collapsibleHandler from './helpers/collapsible';
import injectRegistrationScripts, { injectOtherScripts } from './helpers/registrationScripts';
import { getCookieValue } from './helpers/cookie';
import { showPlansFold } from './components/util/registerUtil';

class Site {
  constructor() {
    this.body = document.body;
    this.breakpoint = {};

    this.menu = new Menu();

    // smooth scroll init

    // const scroll = new SmoothScroll('a[href*="#"]', {
    //   header: '[data-scroll-header]',
    //   speed: 600,
    //   updateURL: false,
    // });

    this.bind();
    this.resize();
  }


  init() {
    // onScroll animations init
    Aos.init({ offset: 40 });

    this.setAsLoaded();
    // this.bubble = new AdBubble();
  }


  setAsLoaded() {
    // this.body.classList.remove('loading');
    const documentBody = this.body;
    if (!documentBody.classList.contains('is-loaded')) {
      this.body.classList.add('is-loaded');
    }
  }


  updateBreakpoint() {
    this.breakpoint = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '');
  }

  static injectOnView() {
    if (window.pageYOffset >= 300 || document.getElementById('lp-ppc-cta') || document.getElementById('demo-lead-register') || document.getElementById('lp-top-registration-sec')) {
      if (!window.siteInfo.isregistered || document.getElementById('demo-lead-register') || window.location.pathname.includes('/ca/legal-intake-guide')) injectRegistrationScripts();
      injectOtherScripts();
    }
  }

  bind() {
    window.addEventListener('resize', () => this.resize());
  }


  resize() {
    // things to update onResize
    this.updateBreakpoint();
    // this.menu.resize();
  }
}


window.addEventListener('pageshow', () => {
  const leadRegistrationFold = document.getElementById('registration');
  const lpRegistrationFold = document.getElementById('intake-bottom-reg-fold') || document.getElementById('lp-top-reg-fold') || document.getElementById('lp-bottom-reg-fold');

  if (getCookieValue('isregistered') && leadRegistrationFold) {
    leadRegistrationFold.classList.add('d-none');
  }
  if (getCookieValue('isregistered') && lpRegistrationFold) {
    if (window.location.pathname === '/ca/lp/legal-answering-service') {
      document.getElementById('lp-top-reg-fold').classList.add('d-none');
      document.getElementById('lp-bottom-reg-fold').classList.add('d-none');
    } else if (window.location.pathname === '/ca/lp/legal-intake-service') {
      lpRegistrationFold.classList.add('d-none');
      showPlansFold(getCookieValue('uniquePin'));
    }
  }
});


window.addEventListener('DOMContentLoaded', () => {
  const AWsite = new Site();
  AWsite.init();
  toggleCookieBanner();
  adBanner();
  Site.injectOnView();
  if (document.querySelectorAll('.collapsible-trigger')) {
    smoothscroll.polyfill();
    collapsibleHandler(500);
  }
});

document.addEventListener('scroll', () => {
  Site.injectOnView();
});
